package com.kaihuoy.components.common

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.components.common.*

@Composable
fun SmallButton(
    text: String,
    onClick: () -> Unit,
    backgroundColor: CSSColorValue? = null,
    enabled: Boolean = true,
    isSelected: Boolean = false,
    isDanger: Boolean = false,
    icon: String? = null
) {
    val bgColor = when {
        isDanger -> KaihuTheme.Danger
        isSelected -> KaihuTheme.PrimaryTeal
        backgroundColor != null -> backgroundColor
        else -> KaihuTheme.Grey
    }

    Button(
        attrs = {
            onClick { if (enabled) onClick() }
            if (!enabled) attr("disabled", "true")

            style {
                padding(8.px, 16.px)
                borderRadius(10.px)
                border(0.px)
                fontSize(0.95.em)
                fontWeight("600")
                cursor(if (enabled) "pointer" else "not-allowed")
                backgroundColor(bgColor)
                color(if (isDanger) Color.white else KaihuTheme.OnPrimary)
                property("box-shadow", "0 2px 8px rgba(0, 0, 0, 0.08)")
                property("transition", "all 0.2s ease")
                minWidth(100.px)

                // Valittu tila
                if (isSelected) {
                    property("box-shadow", "0 0 0 3px rgba(0, 170, 160, 0.4)")
                }

                // Hover-efekti (kevyt)
                if (enabled) {
                    property("box-shadow", "0 3px 10px rgba(0, 0, 0, 0.12)")
                }
            }
        }
    ) {
        if (icon != null) TIcon(icon)
        if (text.isNotBlank()) Text(if (icon != null) " $text" else text)
    }
}
@Composable
fun DelButton(
    text: String,
    onClick: () -> Unit,
    backgroundColor: CSSColorValue? = null,
    enabled: Boolean = true,
    isSelected: Boolean = false,
    isDanger: Boolean = false,
    icon: String? = null
) {
    val isIconOnly = text.isBlank() && icon != null // Tarkistetaan onko kyseessä pelkkä ikoni

    val bgColor = when {
        isDanger -> KaihuTheme.Danger
        isSelected -> KaihuTheme.PrimaryTeal
        backgroundColor != null -> backgroundColor
        else -> KaihuTheme.Grey
    }

    Button(
        attrs = {
            onClick { if (enabled) onClick() }
            if (!enabled) attr("disabled", "true")

            style {
                // Säädetään paddingia: jos pelkkä ikoni, käytetään neliömäisempää paddingia
                if (isIconOnly) {
                    padding(6.px)
                } else {
                    padding(6.px, 12.px) // Pienensin hieman alkuperäisestä (8.px, 16.px)
                }

                borderRadius(8.px) // Hieman pienempi pyöristys sopii pienelle napille
                border(0.px)
                fontSize(0.85.em) // Hieman pienempi teksti
                fontWeight("600")
                cursor(if (enabled) "pointer" else "not-allowed")
                backgroundColor(bgColor)
                color(if (isDanger) Color.white else KaihuTheme.OnPrimary)
                property("box-shadow", "0 2px 8px rgba(0, 0, 0, 0.08)")
                property("transition", "all 0.2s ease")

                // POISTA TAI MUUTA minWidth:
                if (!isIconOnly) {
                    minWidth(80.px) // Pienempi minimileveys tekstin kanssa
                } else {
                    minWidth(32.px) // Hyvin pieni minimi pelkälle ikonille
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                }

                if (isSelected) {
                    property("box-shadow", "0 0 0 3px rgba(0, 170, 160, 0.4)")
                }
            }
        }
    ) {
        if (icon != null) TIcon(icon)
        if (text.isNotBlank()) Text(if (icon != null) " $text" else text)
    }
}